AgrimarketControllers.controller('contributionsController', [
    '$scope', '$rootScope', '$location', '$routeParams',
    function ($scope, $rootScope, $location, $routeParams) {

        $scope.idProduct = $routeParams.idProduct;
        $scope.idCrop = $routeParams.idCrop;

        if (!$rootScope.ModuleMyAccount.Active)
            $location.path('/');

    }
]);